/**
 * NOLAS 2026, (c) Mikaël FOURNY.
 * src/i18n/fr.connexionDepannage.ts
 *
 * Messages de l'encart « Connexion de cette personne » des fiches du
 * back-office (LoginCodeHelp) : historique des codes demandés, renvoi par
 * courriel, affichage d'un code à lire au téléphone. Fusionné dans fr.ts.
 *
 * Mikael - chef de projet - 2026-09-21
 */
export const messagesConnexionDepannageFr: Record<string, string> = {
  'loginCode.title': 'Connexion de cette personne',
  'loginCode.explain':
    'Il n’y a plus de code de stand : la personne se connecte sur /connexion avec son adresse, puis saisit le code à six chiffres reçu par courriel (valable {minutes} minutes). Chaque nouvelle demande remplace le code précédent.',
  'loginCode.loading': 'Lecture des dernières demandes…',
  'loginCode.none': 'Aucun code de connexion demandé pour ce compte.',
  'loginCode.history': 'Dernières demandes de code',
  'loginCode.col.when': 'Demandé le',
  'loginCode.col.mail': 'Courriel',
  'loginCode.col.state': 'État',
  'loginCode.col.attempts': 'Essais',
  'loginCode.mail.accepted': 'accepté par le serveur',
  'loginCode.mail.refused': 'refusé par le serveur',
  'loginCode.mail.unknown': 'inconnu',
  'loginCode.mail.shown': 'affiché à l’organisation, non envoyé',
  'loginCode.state.valide': 'valable',
  'loginCode.state.expire': 'expiré, jamais saisi',
  'loginCode.state.utilise': 'utilisé, connexion réussie',
  'loginCode.state.remplace': 'remplacé par la demande suivante',
  'loginCode.send': 'Renvoyer un code par courriel',
  'loginCode.send.ok': 'Code envoyé par courriel, valable {minutes} minutes.',
  'loginCode.send.refused': 'Le serveur de mail a refusé l’envoi. Affichez le code et communiquez-le de vive voix.',
  'loginCode.send.error': 'Impossible d’envoyer le code. Réessayez dans un instant.',
  'loginCode.reveal': 'Générer et afficher un code',
  'loginCode.reveal.label':
    'Code à communiquer de vive voix, valable {minutes} minutes. Cet affichage est inscrit au journal.',
  'loginCode.reveal.countdown': 'masqué dans {s} s',
  'loginCode.reveal.error': 'Impossible d’afficher un code.',
  'loginCode.copy': 'Copier',
  'loginCode.copy.ok': 'Code copié dans le presse-papiers.',
  'loginCode.copy.error': 'Impossible de copier le code. Sélectionnez-le manuellement.',
  'loginCode.hide': 'Masquer',
  'loginCode.inactive': 'Ce compte n’est pas actif : il ne peut pas se connecter.',
};
